import {UserExpType} from "../../../data/constant/user/UserExpType"
import {UserExpSearchOptionDescription} from "../../../data/description/user/UserExpSearchOptionDescription"
import {UserExpSearchOption} from "../../../data/search-option/user/UserExpSearchOption"
import {ListOptionCheckboxes, ListOptionFieldProps, ListOptionRadioGroup, ListOptionWrapper} from "../../ListOption"
import {Field, Input} from "@fluentui/react-components"
import {StatePair, useStatePair} from "react-type-extension"

export function UserExpSearchOptionField(props: ListOptionFieldProps<UserExpSearchOption>) {
    const input = useStatePair('')
    switch (props.optionKey) {
        case "idNeq":
            return <>
                <ListOptionWrapper
                    {...props}
                    title={UserExpSearchOptionDescription.idNeq}
                    input={input}
                    onApplyClick={(key, value) => {
                        props.onApplyClick(key, value)
                        input.setter('')
                    }}>
                    <Field>
                        <Input
                            value={input.value}
                            onChange={(_, data) => input.setter(data.value)}
                            type={'number'} />
                    </Field>
                </ListOptionWrapper>
            </>
        case "idMin":
            return <>
                <ListOptionWrapper
                    {...props}
                    title={UserExpSearchOptionDescription.idMin}
                    input={input}
                    onApplyClick={(key, value) => {
                        props.onApplyClick(key, value)
                        input.setter('')
                    }}>
                    <Field>
                        <Input
                            value={input.value}
                            onChange={(_, data) => input.setter(data.value)}
                            type={'number'} />
                    </Field>
                </ListOptionWrapper>
            </>
        case "idMax":
            return <>
                <ListOptionWrapper
                    {...props}
                    title={UserExpSearchOptionDescription.idMax}
                    input={input}
                    onApplyClick={(key, value) => {
                        props.onApplyClick(key, value)
                        input.setter('')
                    }}>
                    <Field>
                        <Input
                            value={input.value}
                            onChange={(_, data) => input.setter(data.value)}
                            type={'number'} />
                    </Field>
                </ListOptionWrapper>
            </>
        case "userIdEq":
            return <>
                <ListOptionWrapper
                    {...props}
                    title={UserExpSearchOptionDescription.userIdEq}
                    input={input}
                    onApplyClick={(key, value) => {
                        props.onApplyClick(key, value)
                        input.setter('')
                    }}>
                    <Field>
                        <Input
                            value={input.value}
                            onChange={(_, data) => input.setter(data.value)}
                            type={'number'} />
                    </Field>
                </ListOptionWrapper>
            </>
        case "userIdNeq":
            return <>
                <ListOptionWrapper
                    {...props}
                    title={UserExpSearchOptionDescription.userIdNeq}
                    input={input}
                    onApplyClick={(key, value) => {
                        props.onApplyClick(key, value)
                        input.setter('')
                    }}>
                    <Field>
                        <Input
                            value={input.value}
                            onChange={(_, data) => input.setter(data.value)}
                            type={'number'} />
                    </Field>
                </ListOptionWrapper>
            </>
        case "userIdMin":
            return <>
                <ListOptionWrapper
                    {...props}
                    title={UserExpSearchOptionDescription.userIdMin}
                    input={input}
                    onApplyClick={(key, value) => {
                        props.onApplyClick(key, value)
                        input.setter('')
                    }}>
                    <Field>
                        <Input
                            value={input.value}
                            onChange={(_, data) => input.setter(data.value)}
                            type={'number'} />
                    </Field>
                </ListOptionWrapper>
            </>
        case "userIdMax":
            return <>
                <ListOptionWrapper
                    {...props}
                    title={UserExpSearchOptionDescription.userIdMax}
                    input={input}
                    onApplyClick={(key, value) => {
                        props.onApplyClick(key, value)
                        input.setter('')
                    }}>
                    <Field>
                        <Input
                            value={input.value}
                            onChange={(_, data) => input.setter(data.value)}
                            type={'number'} />
                    </Field>
                </ListOptionWrapper>
            </>
        case "creatorIdEq":
            return <>
                <ListOptionWrapper
                    {...props}
                    title={UserExpSearchOptionDescription.creatorIdEq}
                    input={input}
                    onApplyClick={(key, value) => {
                        props.onApplyClick(key, value)
                        input.setter('')
                    }}>
                    <Field>
                        <Input
                            value={input.value}
                            onChange={(_, data) => input.setter(data.value)}
                            type={'number'} />
                    </Field>
                </ListOptionWrapper>
            </>
        case "creatorIdNeq":
            return <>
                <ListOptionWrapper
                    {...props}
                    title={UserExpSearchOptionDescription.creatorIdNeq}
                    input={input}
                    onApplyClick={(key, value) => {
                        props.onApplyClick(key, value)
                        input.setter('')
                    }}>
                    <Field>
                        <Input
                            value={input.value}
                            onChange={(_, data) => input.setter(data.value)}
                            type={'number'} />
                    </Field>
                </ListOptionWrapper>
            </>
        case "creatorIdMin":
            return <>
                <ListOptionWrapper
                    {...props}
                    title={UserExpSearchOptionDescription.creatorIdMin}
                    input={input}
                    onApplyClick={(key, value) => {
                        props.onApplyClick(key, value)
                        input.setter('')
                    }}>
                    <Field>
                        <Input
                            value={input.value}
                            onChange={(_, data) => input.setter(data.value)}
                            type={'number'} />
                    </Field>
                </ListOptionWrapper>
            </>
        case "creatorIdMax":
            return <>
                <ListOptionWrapper
                    {...props}
                    title={UserExpSearchOptionDescription.creatorIdMax}
                    input={input}
                    onApplyClick={(key, value) => {
                        props.onApplyClick(key, value)
                        input.setter('')
                    }}>
                    <Field>
                        <Input
                            value={input.value}
                            onChange={(_, data) => input.setter(data.value)}
                            type={'number'} />
                    </Field>
                </ListOptionWrapper>
            </>
        case "creatorIdIsNull":
            return <>
                <ListOptionWrapper
                    {...props}
                    title={UserExpSearchOptionDescription.creatorIdIsNull}
                    input={input}
                    onApplyClick={(key, value) => {
                        props.onApplyClick(key, value)
                        input.setter('')
                    }}>
                    <Field>
                        <Input
                            value={input.value}
                            onChange={(_, data) => input.setter(data.value)}
                            type={'number'} />
                    </Field>
                </ListOptionWrapper>
            </>
        case "typeEq":
            return <>
                <ListOptionWrapper
                    {...props}
                    title={UserExpSearchOptionDescription.typeEq}
                    input={input}
                    onApplyClick={(key, value) => {
                        props.onApplyClick(key, value)
                        input.setter('')
                    }}>
                    <ListOptionRadioGroup
                        {...props}
                        input={input}
                        selections={UserExpType.selections} />
                </ListOptionWrapper>
            </>
        case "typeNeq":
            return <>
                <ListOptionWrapper
                    {...props}
                    title={UserExpSearchOptionDescription.typeNeq}
                    input={input}
                    onApplyClick={(key, value) => {
                        props.onApplyClick(key, value)
                        input.setter('')
                    }}>
                    <ListOptionRadioGroup
                        {...props}
                        input={input}
                        selections={UserExpType.selections} />
                </ListOptionWrapper>
            </>
        case "typeMin":
            return <>
                <ListOptionWrapper
                    {...props}
                    title={UserExpSearchOptionDescription.typeMin}
                    input={input}
                    onApplyClick={(key, value) => {
                        props.onApplyClick(key, value)
                        input.setter('')
                    }}>
                    <ListOptionRadioGroup
                        {...props}
                        input={input}
                        selections={UserExpType.selections} />
                </ListOptionWrapper>
            </>
        case "typeMax":
            return <>
                <ListOptionWrapper
                    {...props}
                    title={UserExpSearchOptionDescription.typeMax}
                    input={input}
                    onApplyClick={(key, value) => {
                        props.onApplyClick(key, value)
                        input.setter('')
                    }}>
                    <ListOptionRadioGroup
                        {...props}
                        input={input}
                        selections={UserExpType.selections} />
                </ListOptionWrapper>
            </>
        case "typeIn":
            return <>
                <ListOptionWrapper
                    {...props}
                    title={UserExpSearchOptionDescription.typeIn}
                    input={input}
                    onApplyClick={(key, value) => {
                        props.onApplyClick(key, value)
                        input.setter('')
                    }}>
                    <ListOptionCheckboxes
                        {...props}
                        input={input}
                        selections={UserExpType.selections} />
                </ListOptionWrapper>
            </>
        case "amountEq":
            return <>
                <ListOptionWrapper
                    {...props}
                    title={UserExpSearchOptionDescription.amountEq}
                    input={input}
                    onApplyClick={(key, value) => {
                        props.onApplyClick(key, value)
                        input.setter('')
                    }}>
                    <Field>
                        <Input
                            value={input.value}
                            onChange={(_, data) => input.setter(data.value)}
                            type={'number'} />
                    </Field>
                </ListOptionWrapper>
            </>
        case "amountNeq":
            return <>
                <ListOptionWrapper
                    {...props}
                    title={UserExpSearchOptionDescription.amountNeq}
                    input={input}
                    onApplyClick={(key, value) => {
                        props.onApplyClick(key, value)
                        input.setter('')
                    }}>
                    <Field>
                        <Input
                            value={input.value}
                            onChange={(_, data) => input.setter(data.value)}
                            type={'number'} />
                    </Field>
                </ListOptionWrapper>
            </>
        case "amountMin":
            return <>
                <ListOptionWrapper
                    {...props}
                    title={UserExpSearchOptionDescription.amountMin}
                    input={input}
                    onApplyClick={(key, value) => {
                        props.onApplyClick(key, value)
                        input.setter('')
                    }}>
                    <Field>
                        <Input
                            value={input.value}
                            onChange={(_, data) => input.setter(data.value)}
                            type={'number'} />
                    </Field>
                </ListOptionWrapper>
            </>
        case "amountMax":
            return <>
                <ListOptionWrapper
                    {...props}
                    title={UserExpSearchOptionDescription.amountMax}
                    input={input}
                    onApplyClick={(key, value) => {
                        props.onApplyClick(key, value)
                        input.setter('')
                    }}>
                    <Field>
                        <Input
                            value={input.value}
                            onChange={(_, data) => input.setter(data.value)}
                            type={'number'} />
                    </Field>
                </ListOptionWrapper>
            </>
        case "lastAccumulationEq":
            return <>
                <ListOptionWrapper
                    {...props}
                    title={UserExpSearchOptionDescription.lastAccumulationEq}
                    input={input}
                    onApplyClick={(key, value) => {
                        props.onApplyClick(key, value)
                        input.setter('')
                    }}>
                    <Field>
                        <Input
                            value={input.value}
                            onChange={(_, data) => input.setter(data.value)}
                            type={'number'} />
                    </Field>
                </ListOptionWrapper>
            </>
        case "lastAccumulationNeq":
            return <>
                <ListOptionWrapper
                    {...props}
                    title={UserExpSearchOptionDescription.lastAccumulationNeq}
                    input={input}
                    onApplyClick={(key, value) => {
                        props.onApplyClick(key, value)
                        input.setter('')
                    }}>
                    <Field>
                        <Input
                            value={input.value}
                            onChange={(_, data) => input.setter(data.value)}
                            type={'number'} />
                    </Field>
                </ListOptionWrapper>
            </>
        case "lastAccumulationMin":
            return <>
                <ListOptionWrapper
                    {...props}
                    title={UserExpSearchOptionDescription.lastAccumulationMin}
                    input={input}
                    onApplyClick={(key, value) => {
                        props.onApplyClick(key, value)
                        input.setter('')
                    }}>
                    <Field>
                        <Input
                            value={input.value}
                            onChange={(_, data) => input.setter(data.value)}
                            type={'number'} />
                    </Field>
                </ListOptionWrapper>
            </>
        case "lastAccumulationMax":
            return <>
                <ListOptionWrapper
                    {...props}
                    title={UserExpSearchOptionDescription.lastAccumulationMax}
                    input={input}
                    onApplyClick={(key, value) => {
                        props.onApplyClick(key, value)
                        input.setter('')
                    }}>
                    <Field>
                        <Input
                            value={input.value}
                            onChange={(_, data) => input.setter(data.value)}
                            type={'number'} />
                    </Field>
                </ListOptionWrapper>
            </>
        case "inDayEq":
            return <>
                <ListOptionWrapper
                    {...props}
                    title={UserExpSearchOptionDescription.inDayEq}
                    input={input}
                    onApplyClick={(key, value) => {
                        props.onApplyClick(key, value)
                        input.setter('')
                    }}>
                    <Field>
                        <Input
                            value={input.value}
                            onChange={(_, data) => input.setter(data.value)}
                            type={'number'} />
                    </Field>
                </ListOptionWrapper>
            </>
        case "inDayNeq":
            return <>
                <ListOptionWrapper
                    {...props}
                    title={UserExpSearchOptionDescription.inDayNeq}
                    input={input}
                    onApplyClick={(key, value) => {
                        props.onApplyClick(key, value)
                        input.setter('')
                    }}>
                    <Field>
                        <Input
                            value={input.value}
                            onChange={(_, data) => input.setter(data.value)}
                            type={'number'} />
                    </Field>
                </ListOptionWrapper>
            </>
        case "inDayMin":
            return <>
                <ListOptionWrapper
                    {...props}
                    title={UserExpSearchOptionDescription.inDayMin}
                    input={input}
                    onApplyClick={(key, value) => {
                        props.onApplyClick(key, value)
                        input.setter('')
                    }}>
                    <Field>
                        <Input
                            value={input.value}
                            onChange={(_, data) => input.setter(data.value)}
                            type={'number'} />
                    </Field>
                </ListOptionWrapper>
            </>
        case "inDayMax":
            return <>
                <ListOptionWrapper
                    {...props}
                    title={UserExpSearchOptionDescription.inDayMax}
                    input={input}
                    onApplyClick={(key, value) => {
                        props.onApplyClick(key, value)
                        input.setter('')
                    }}>
                    <Field>
                        <Input
                            value={input.value}
                            onChange={(_, data) => input.setter(data.value)}
                            type={'number'} />
                    </Field>
                </ListOptionWrapper>
            </>
        case "inWeekEq":
            return <>
                <ListOptionWrapper
                    {...props}
                    title={UserExpSearchOptionDescription.inWeekEq}
                    input={input}
                    onApplyClick={(key, value) => {
                        props.onApplyClick(key, value)
                        input.setter('')
                    }}>
                    <Field>
                        <Input
                            value={input.value}
                            onChange={(_, data) => input.setter(data.value)}
                            type={'number'} />
                    </Field>
                </ListOptionWrapper>
            </>
        case "inWeekNeq":
            return <>
                <ListOptionWrapper
                    {...props}
                    title={UserExpSearchOptionDescription.inWeekNeq}
                    input={input}
                    onApplyClick={(key, value) => {
                        props.onApplyClick(key, value)
                        input.setter('')
                    }}>
                    <Field>
                        <Input
                            value={input.value}
                            onChange={(_, data) => input.setter(data.value)}
                            type={'number'} />
                    </Field>
                </ListOptionWrapper>
            </>
        case "inWeekMin":
            return <>
                <ListOptionWrapper
                    {...props}
                    title={UserExpSearchOptionDescription.inWeekMin}
                    input={input}
                    onApplyClick={(key, value) => {
                        props.onApplyClick(key, value)
                        input.setter('')
                    }}>
                    <Field>
                        <Input
                            value={input.value}
                            onChange={(_, data) => input.setter(data.value)}
                            type={'number'} />
                    </Field>
                </ListOptionWrapper>
            </>
        case "inWeekMax":
            return <>
                <ListOptionWrapper
                    {...props}
                    title={UserExpSearchOptionDescription.inWeekMax}
                    input={input}
                    onApplyClick={(key, value) => {
                        props.onApplyClick(key, value)
                        input.setter('')
                    }}>
                    <Field>
                        <Input
                            value={input.value}
                            onChange={(_, data) => input.setter(data.value)}
                            type={'number'} />
                    </Field>
                </ListOptionWrapper>
            </>
        case "inMonthEq":
            return <>
                <ListOptionWrapper
                    {...props}
                    title={UserExpSearchOptionDescription.inMonthEq}
                    input={input}
                    onApplyClick={(key, value) => {
                        props.onApplyClick(key, value)
                        input.setter('')
                    }}>
                    <Field>
                        <Input
                            value={input.value}
                            onChange={(_, data) => input.setter(data.value)}
                            type={'number'} />
                    </Field>
                </ListOptionWrapper>
            </>
        case "inMonthNeq":
            return <>
                <ListOptionWrapper
                    {...props}
                    title={UserExpSearchOptionDescription.inMonthNeq}
                    input={input}
                    onApplyClick={(key, value) => {
                        props.onApplyClick(key, value)
                        input.setter('')
                    }}>
                    <Field>
                        <Input
                            value={input.value}
                            onChange={(_, data) => input.setter(data.value)}
                            type={'number'} />
                    </Field>
                </ListOptionWrapper>
            </>
        case "inMonthMin":
            return <>
                <ListOptionWrapper
                    {...props}
                    title={UserExpSearchOptionDescription.inMonthMin}
                    input={input}
                    onApplyClick={(key, value) => {
                        props.onApplyClick(key, value)
                        input.setter('')
                    }}>
                    <Field>
                        <Input
                            value={input.value}
                            onChange={(_, data) => input.setter(data.value)}
                            type={'number'} />
                    </Field>
                </ListOptionWrapper>
            </>
        case "inMonthMax":
            return <>
                <ListOptionWrapper
                    {...props}
                    title={UserExpSearchOptionDescription.inMonthMax}
                    input={input}
                    onApplyClick={(key, value) => {
                        props.onApplyClick(key, value)
                        input.setter('')
                    }}>
                    <Field>
                        <Input
                            value={input.value}
                            onChange={(_, data) => input.setter(data.value)}
                            type={'number'} />
                    </Field>
                </ListOptionWrapper>
            </>
        case "inQuarterEq":
            return <>
                <ListOptionWrapper
                    {...props}
                    title={UserExpSearchOptionDescription.inQuarterEq}
                    input={input}
                    onApplyClick={(key, value) => {
                        props.onApplyClick(key, value)
                        input.setter('')
                    }}>
                    <Field>
                        <Input
                            value={input.value}
                            onChange={(_, data) => input.setter(data.value)}
                            type={'number'} />
                    </Field>
                </ListOptionWrapper>
            </>
        case "inQuarterNeq":
            return <>
                <ListOptionWrapper
                    {...props}
                    title={UserExpSearchOptionDescription.inQuarterNeq}
                    input={input}
                    onApplyClick={(key, value) => {
                        props.onApplyClick(key, value)
                        input.setter('')
                    }}>
                    <Field>
                        <Input
                            value={input.value}
                            onChange={(_, data) => input.setter(data.value)}
                            type={'number'} />
                    </Field>
                </ListOptionWrapper>
            </>
        case "inQuarterMin":
            return <>
                <ListOptionWrapper
                    {...props}
                    title={UserExpSearchOptionDescription.inQuarterMin}
                    input={input}
                    onApplyClick={(key, value) => {
                        props.onApplyClick(key, value)
                        input.setter('')
                    }}>
                    <Field>
                        <Input
                            value={input.value}
                            onChange={(_, data) => input.setter(data.value)}
                            type={'number'} />
                    </Field>
                </ListOptionWrapper>
            </>
        case "inQuarterMax":
            return <>
                <ListOptionWrapper
                    {...props}
                    title={UserExpSearchOptionDescription.inQuarterMax}
                    input={input}
                    onApplyClick={(key, value) => {
                        props.onApplyClick(key, value)
                        input.setter('')
                    }}>
                    <Field>
                        <Input
                            value={input.value}
                            onChange={(_, data) => input.setter(data.value)}
                            type={'number'} />
                    </Field>
                </ListOptionWrapper>
            </>
        case "inHalfEq":
            return <>
                <ListOptionWrapper
                    {...props}
                    title={UserExpSearchOptionDescription.inHalfEq}
                    input={input}
                    onApplyClick={(key, value) => {
                        props.onApplyClick(key, value)
                        input.setter('')
                    }}>
                    <Field>
                        <Input
                            value={input.value}
                            onChange={(_, data) => input.setter(data.value)}
                            type={'number'} />
                    </Field>
                </ListOptionWrapper>
            </>
        case "inHalfNeq":
            return <>
                <ListOptionWrapper
                    {...props}
                    title={UserExpSearchOptionDescription.inHalfNeq}
                    input={input}
                    onApplyClick={(key, value) => {
                        props.onApplyClick(key, value)
                        input.setter('')
                    }}>
                    <Field>
                        <Input
                            value={input.value}
                            onChange={(_, data) => input.setter(data.value)}
                            type={'number'} />
                    </Field>
                </ListOptionWrapper>
            </>
        case "inHalfMin":
            return <>
                <ListOptionWrapper
                    {...props}
                    title={UserExpSearchOptionDescription.inHalfMin}
                    input={input}
                    onApplyClick={(key, value) => {
                        props.onApplyClick(key, value)
                        input.setter('')
                    }}>
                    <Field>
                        <Input
                            value={input.value}
                            onChange={(_, data) => input.setter(data.value)}
                            type={'number'} />
                    </Field>
                </ListOptionWrapper>
            </>
        case "inHalfMax":
            return <>
                <ListOptionWrapper
                    {...props}
                    title={UserExpSearchOptionDescription.inHalfMax}
                    input={input}
                    onApplyClick={(key, value) => {
                        props.onApplyClick(key, value)
                        input.setter('')
                    }}>
                    <Field>
                        <Input
                            value={input.value}
                            onChange={(_, data) => input.setter(data.value)}
                            type={'number'} />
                    </Field>
                </ListOptionWrapper>
            </>
        case "inYearEq":
            return <>
                <ListOptionWrapper
                    {...props}
                    title={UserExpSearchOptionDescription.inYearEq}
                    input={input}
                    onApplyClick={(key, value) => {
                        props.onApplyClick(key, value)
                        input.setter('')
                    }}>
                    <Field>
                        <Input
                            value={input.value}
                            onChange={(_, data) => input.setter(data.value)}
                            type={'number'} />
                    </Field>
                </ListOptionWrapper>
            </>
        case "inYearNeq":
            return <>
                <ListOptionWrapper
                    {...props}
                    title={UserExpSearchOptionDescription.inYearNeq}
                    input={input}
                    onApplyClick={(key, value) => {
                        props.onApplyClick(key, value)
                        input.setter('')
                    }}>
                    <Field>
                        <Input
                            value={input.value}
                            onChange={(_, data) => input.setter(data.value)}
                            type={'number'} />
                    </Field>
                </ListOptionWrapper>
            </>
        case "inYearMin":
            return <>
                <ListOptionWrapper
                    {...props}
                    title={UserExpSearchOptionDescription.inYearMin}
                    input={input}
                    onApplyClick={(key, value) => {
                        props.onApplyClick(key, value)
                        input.setter('')
                    }}>
                    <Field>
                        <Input
                            value={input.value}
                            onChange={(_, data) => input.setter(data.value)}
                            type={'number'} />
                    </Field>
                </ListOptionWrapper>
            </>
        case "inYearMax":
            return <>
                <ListOptionWrapper
                    {...props}
                    title={UserExpSearchOptionDescription.inYearMax}
                    input={input}
                    onApplyClick={(key, value) => {
                        props.onApplyClick(key, value)
                        input.setter('')
                    }}>
                    <Field>
                        <Input
                            value={input.value}
                            onChange={(_, data) => input.setter(data.value)}
                            type={'number'} />
                    </Field>
                </ListOptionWrapper>
            </>
        case "createdAtEq":
            return <>
                <ListOptionWrapper
                    {...props}
                    title={UserExpSearchOptionDescription.createdAtEq}
                    input={input}
                    onApplyClick={(key, value) => {
                        props.onApplyClick(key, value)
                        input.setter('')
                    }}>
                    <Field>
                        <Input
                            value={input.value}
                            onChange={(_, data) => input.setter(data.value)}
                            type={'text'} />
                    </Field>
                </ListOptionWrapper>
            </>
        case "createdAtNeq":
            return <>
                <ListOptionWrapper
                    {...props}
                    title={UserExpSearchOptionDescription.createdAtNeq}
                    input={input}
                    onApplyClick={(key, value) => {
                        props.onApplyClick(key, value)
                        input.setter('')
                    }}>
                    <Field>
                        <Input
                            value={input.value}
                            onChange={(_, data) => input.setter(data.value)}
                            type={'text'} />
                    </Field>
                </ListOptionWrapper>
            </>
        case "createdAtMin":
            return <>
                <ListOptionWrapper
                    {...props}
                    title={UserExpSearchOptionDescription.createdAtMin}
                    input={input}
                    onApplyClick={(key, value) => {
                        props.onApplyClick(key, value)
                        input.setter('')
                    }}>
                    <Field>
                        <Input
                            value={input.value}
                            onChange={(_, data) => input.setter(data.value)}
                            type={'text'} />
                    </Field>
                </ListOptionWrapper>
            </>
        case "createdAtMax":
            return <>
                <ListOptionWrapper
                    {...props}
                    title={UserExpSearchOptionDescription.createdAtMax}
                    input={input}
                    onApplyClick={(key, value) => {
                        props.onApplyClick(key, value)
                        input.setter('')
                    }}>
                    <Field>
                        <Input
                            value={input.value}
                            onChange={(_, data) => input.setter(data.value)}
                            type={'text'} />
                    </Field>
                </ListOptionWrapper>
            </>
    }
}

export function applyUserExpSearchOption(key: keyof UserExpSearchOption, value: string, into: StatePair<UserExpSearchOption>) {
    switch (key) {
        case "idNeq":
            into.setter({
                ...into.value,
                idNeq: BigInt(value)
            })
            break
        case "idMin":
            into.setter({
                ...into.value,
                idMin: BigInt(value)
            })
            break
        case "idMax":
            into.setter({
                ...into.value,
                idMax: BigInt(value)
            })
            break
        case "userIdEq":
            into.setter({
                ...into.value,
                userIdEq: BigInt(value)
            })
            break
        case "userIdNeq":
            into.setter({
                ...into.value,
                userIdNeq: BigInt(value)
            })
            break
        case "userIdMin":
            into.setter({
                ...into.value,
                userIdMin: BigInt(value)
            })
            break
        case "userIdMax":
            into.setter({
                ...into.value,
                userIdMax: BigInt(value)
            })
            break
        case "creatorIdEq":
            into.setter({
                ...into.value,
                creatorIdEq: BigInt(value)
            })
            break
        case "creatorIdNeq":
            into.setter({
                ...into.value,
                creatorIdNeq: BigInt(value)
            })
            break
        case "creatorIdMin":
            into.setter({
                ...into.value,
                creatorIdMin: BigInt(value)
            })
            break
        case "creatorIdMax":
            into.setter({
                ...into.value,
                creatorIdMax: BigInt(value)
            })
            break
        case "creatorIdIsNull":
            into.setter({
                ...into.value,
                creatorIdIsNull: Boolean(value)
            })
            break
        case "typeEq":
            into.setter({
                ...into.value,
                typeEq: value as UserExpType
            })
            break
        case "typeNeq":
            into.setter({
                ...into.value,
                typeNeq: value as UserExpType
            })
            break
        case "typeMin":
            into.setter({
                ...into.value,
                typeMin: value as UserExpType
            })
            break
        case "typeMax":
            into.setter({
                ...into.value,
                typeMax: value as UserExpType
            })
            break
        case "typeIn":
            into.setter({
                ...into.value,
                typeIn: value
                    .split('|')
                    .map(e => e as UserExpType)
            })
            break
        case "amountEq":
            into.setter({
                ...into.value,
                amountEq: Number(value)
            })
            break
        case "amountNeq":
            into.setter({
                ...into.value,
                amountNeq: Number(value)
            })
            break
        case "amountMin":
            into.setter({
                ...into.value,
                amountMin: Number(value)
            })
            break
        case "amountMax":
            into.setter({
                ...into.value,
                amountMax: Number(value)
            })
            break
        case "lastAccumulationEq":
            into.setter({
                ...into.value,
                lastAccumulationEq: Number(value)
            })
            break
        case "lastAccumulationNeq":
            into.setter({
                ...into.value,
                lastAccumulationNeq: Number(value)
            })
            break
        case "lastAccumulationMin":
            into.setter({
                ...into.value,
                lastAccumulationMin: Number(value)
            })
            break
        case "lastAccumulationMax":
            into.setter({
                ...into.value,
                lastAccumulationMax: Number(value)
            })
            break
        case "inDayEq":
            into.setter({
                ...into.value,
                inDayEq: Number(value)
            })
            break
        case "inDayNeq":
            into.setter({
                ...into.value,
                inDayNeq: Number(value)
            })
            break
        case "inDayMin":
            into.setter({
                ...into.value,
                inDayMin: Number(value)
            })
            break
        case "inDayMax":
            into.setter({
                ...into.value,
                inDayMax: Number(value)
            })
            break
        case "inWeekEq":
            into.setter({
                ...into.value,
                inWeekEq: Number(value)
            })
            break
        case "inWeekNeq":
            into.setter({
                ...into.value,
                inWeekNeq: Number(value)
            })
            break
        case "inWeekMin":
            into.setter({
                ...into.value,
                inWeekMin: Number(value)
            })
            break
        case "inWeekMax":
            into.setter({
                ...into.value,
                inWeekMax: Number(value)
            })
            break
        case "inMonthEq":
            into.setter({
                ...into.value,
                inMonthEq: Number(value)
            })
            break
        case "inMonthNeq":
            into.setter({
                ...into.value,
                inMonthNeq: Number(value)
            })
            break
        case "inMonthMin":
            into.setter({
                ...into.value,
                inMonthMin: Number(value)
            })
            break
        case "inMonthMax":
            into.setter({
                ...into.value,
                inMonthMax: Number(value)
            })
            break
        case "inQuarterEq":
            into.setter({
                ...into.value,
                inQuarterEq: Number(value)
            })
            break
        case "inQuarterNeq":
            into.setter({
                ...into.value,
                inQuarterNeq: Number(value)
            })
            break
        case "inQuarterMin":
            into.setter({
                ...into.value,
                inQuarterMin: Number(value)
            })
            break
        case "inQuarterMax":
            into.setter({
                ...into.value,
                inQuarterMax: Number(value)
            })
            break
        case "inHalfEq":
            into.setter({
                ...into.value,
                inHalfEq: Number(value)
            })
            break
        case "inHalfNeq":
            into.setter({
                ...into.value,
                inHalfNeq: Number(value)
            })
            break
        case "inHalfMin":
            into.setter({
                ...into.value,
                inHalfMin: Number(value)
            })
            break
        case "inHalfMax":
            into.setter({
                ...into.value,
                inHalfMax: Number(value)
            })
            break
        case "inYearEq":
            into.setter({
                ...into.value,
                inYearEq: Number(value)
            })
            break
        case "inYearNeq":
            into.setter({
                ...into.value,
                inYearNeq: Number(value)
            })
            break
        case "inYearMin":
            into.setter({
                ...into.value,
                inYearMin: Number(value)
            })
            break
        case "inYearMax":
            into.setter({
                ...into.value,
                inYearMax: Number(value)
            })
            break
        case "createdAtEq":
            into.setter({
                ...into.value,
                createdAtEq: new Date(value)
            })
            break
        case "createdAtNeq":
            into.setter({
                ...into.value,
                createdAtNeq: new Date(value)
            })
            break
        case "createdAtMin":
            into.setter({
                ...into.value,
                createdAtMin: new Date(value)
            })
            break
        case "createdAtMax":
            into.setter({
                ...into.value,
                createdAtMax: new Date(value)
            })
            break
    }
}
